// extracted by mini-css-extract-plugin
export default {"dots":"TutorialProgress-module__dots--k70EM","dot":"TutorialProgress-module__dot--bI6VY","active":"TutorialProgress-module__active--NKt0i"};